



















import {
  Vue, Component, Prop, Watch, Mixins, Emit, PropSync,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import {
  contains, pickBy, values, map,
} from 'ramda'
import {
  update, field, collection, get, query, where, set, add, value,
} from 'typesaurus'
import {
  getModule,
} from 'vuex-module-decorators'
import md5 from 'md5'
import firebase from 'firebase'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import TaskStore from '../../store/modules/tasks'
import { db } from '../../firebase/init'
import { TaskType, CommentType, CouponType } from '../../types'

type TagType = {
  id:string,
  text:string,
}

@Component({
  components: {
  },
})
export default class SingleCoupon extends Mixins(MainMixin) {
  @Prop() data!:CouponType

  @Prop({ default: true }) showComments!:boolean

  @Prop({ default: true }) showTags!:boolean

  @Emit()
  showdetails() {
    console.log('doing show details')
    return Object.assign(this.data, {
      data: this.cData, expired: this.isExpired, expirationText: this.expiration, validLocation: this.validLocation, redeemedDate: this.redeemedDate, canRedeem: this.canRedeem,
    })
  }

  get expiration() {
    if (!this.data.expiration) return 'No Expiration'
    return dayjs(this.data.expiration).format('MM/DD/YYYY')
  }

  get isExpired() {
    if (!this.data.expiration) return false
    return dayjs().isAfter(this.data.expiration)
  }

  get isRedeemed() {
    console.log('here is redeemed: ', this.data.redeemed)
    if (this.data.redeemed) return true
    return false
  }

  get redeemedDate() {
    if (!this.data.redeemed) return ''
    return dayjs(this.data.redeemed.toDate()).format('M/D/YY [at] h:mma')
  }

  get createdDate() {
    if (!this.data.created) return ''
    console.log('here created date: ', this.data.created.toDate())
    return dayjs(this.data.created.toDate()).format('M/D/YY [at] h:mma')
  }

  get canRedeem() {
    if (this.isRedeemed || this.isExpired || !this.validLocation) return false
    return true
  }

  get cData() {
    if (this.isRedeemed) {
      return {
        title: 'Redeemed',
        color: 'green',
        icon: 'mdi-check',
      }
    } if (this.isExpired) {
      return {
        title: 'Expired',
        color: 'red',
        icon: 'mdi-close-circle',
      }
    } if (!this.validLocation) {
      return {
        title: 'Invalid',
        color: 'red',
        icon: 'mdi-file-cancel',
      }
    } return {
      title: 'Valid',
      color: '#1976d2',
      icon: 'mdi-ticket',
    }
  }

  get validLocation() {
    return (!this.data.singleLocation || this.data.singleLocation === this.$store.getters.location)
  }

  // data:any = {
  //   notes: 'From $5 Text Club',
  //   spend: null,
  //   creationApis: [
  //     {
  //       type: 'infusionsoft',
  //       value: 'inCobbsTextClub',
  //     },
  //   ],
  //   expiration: '2020-03-07',
  //   details: 'Take $5 Off Your Next Tab',
  //   redemptionApis: [
  //     {
  //       type: 'infusionsoft',
  //       value: 'redeemedCobbsTextClub',
  //     },
  //   ],
  //   value: '$5 Off Bill',
  //   customer: 'f224',
  //   redeemed: null,
  //   redemptionNotes: '',
  //   redeemedBy: '',
  //   singleLocation: '',
  //   group: 'cobbs',
  //   categories: [
  //     'Text Club',
  //     'Promo',
  //   ],
  //   internalValue: '5',
  // }
}

